import { asyncRequest, registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "product-recommendations",
  class ProductRecommendations extends WYATTElement {
    constructor() {
      super();

      const observer = new IntersectionObserver(this.handleIntersection, {
        rootMargin: "0px 0px 200px 0px",
      });

      observer.observe(this);
    }

    handleIntersection = async (entries, observer) => {
      if (!entries[0].isIntersecting) {
        return;
      }

      observer.unobserve(this);

      const html = await asyncRequest(this.config.endpoint);

      this.publish(WYATT.PubSub.events.updateDOM, [
        {
          liveRegion: `product-recommendations-${this.config.sectionID}`,
          html,
        },
      ]);
    };
  },
);
